import { RowProps } from '@creditsights/styleguide-web/components/DataView';
import { DataViewItemConfiguration } from '@creditsights/styleguide-web/components/DataView/DataView.types';
import { MouseEvent } from 'react';

export const getRouteToCallback = <I>(configuration: DataViewItemConfiguration | undefined, item: I): string => {
  const itemIdKey = configuration?.getIdKey?.() || 'id';
  return configuration?.routeToCallback
    ? configuration.routeToCallback(item[itemIdKey], configuration.isChildRoute)
    : '';
};

export const getInitialConditionalAction =
  <I>(
    configuration: DataViewItemConfiguration | undefined,
    row: RowProps,
    props: { onItemClick? } | undefined,
    item: I
  ) =>
  (e: MouseEvent<HTMLElement>): void => {
    if (configuration?.shouldAllowInitialAction?.(row)) {
      e.preventDefault();
      props?.onItemClick?.(item, e);
    }
  };

export const formatCurrencyAmount = (amount: number): string =>
  amount.toLocaleString('en-US', {
    maximumFractionDigits: 2,
  });
